import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentsService {
  baseUrl: string;
  sessionTime: number;
  timeBeforeClose: number;

  constructor() {
    this.baseUrl = environment.apiBaseUrl;
    this.sessionTime = environment.sessionTime;
    this.timeBeforeClose = environment.timeBeforeClose;
  }
}
